<template>
    <modal :show="show" v-on:update:show="handleModalClose">
        <template slot="header">
            <h5 class="modal-title">{{ ivr.name }} - Add Keypress</h5>
        </template>

        <template>
            <form  v-on:submit.prevent="noop">
                <div class="row">
                    <div class="col">
                        <base-input label="Keypress"
                                    type="text"
                                    placeholder="Enter Keypress number"
                                    v-validate="'max:4'"
                                    v-model="button"
                                    name="button"
                                    required
                                    :error="getError('button')"
                                    v-on:keyup.enter="validate"
                        >
                            <small slot="helperText" id="nameHelp" class="form-text text-muted">The button can be any
                                number up to 4 digits.
                            </small>
                        </base-input>
                    </div>
                </div>
            </form>
        </template>


        <template slot="footer">
            <base-button type="primary" native-type="submit" @click.prevent="validate"
                         :loading="saving"> Save changes
            </base-button>
            <base-button type="secondary" @click.native="$emit('update:show', false)">Close</base-button>
        </template>
    </modal>
</template>

<script>
    import Modal from "../../components/Modal";

    export default {
        name: "AddButtonModal",
        components: {
            Modal,
        },
        props: {
            ivr: Object,
            show: Boolean,
        },
        data() {
            return {
                saving: false,
                button: null,
            }
        },
        computed: {},
        methods: {
            getError(fieldName) {
                return this.errors.first(fieldName)
            },
            validate() {
                this.$validator.validateAll().then(isValid => {
                    if (isValid) {
                        this.addButton()
                    }
                })
            },
            handleModalClose() {
                this.$emit('update:show', false);
            },
            addButton() {
                this.saving = true;
                let ivr = this.ivr.id;
                let button = this.button;
                this.$store.dispatch('ivr/addButton', {ivr, button}).then(() => {
                    this.$notify({
                        verticalAlign: 'bottom',
                        horizontalAlign: 'right',
                        message: 'Your button was added!',
                        type: "success",
                        icon: "fal fa-check",
                        title: "Added!"
                    });
                    this.$emit('success');
                    this.$emit('update:show', false)
                }).catch((result) => {

                    this.$notify({
                        position: "bottom-right",
                        message: 'Unable to add button. Does the button already exist?',
                        type: "error",
                        icon: "fal fa-times",
                        title: "Error!"
                    });
                }).finally(() => {
                    this.saving = false;
                    this.button = null;
                });

            },
        },
        mounted() {
        },
        // watch: {
        //     whenever sipdevice changes, this function will run
        // ivr: function (newIVR, oldIVR) {
        //     if (this.ivr != null) {
        //         this.$emit('update:show', true)
        //     }
        // },
        // },
    }
</script>

<style scoped>

</style>
